module.exports = __webpack_public_path__ + "static/media/ULTRACEMCO_F1.0a4d2562.txt";